/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface SkillMapCellTargetPayload {
    cmId: string;
    cmcId: string;
    target: string;
    comment?: string;
}

export interface SkillMapCellTargetResponse {
    skillMapName: string;
    updateTime: string;
    updator: string;
}

class SkillMapCellTargetService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "skillMapCellTarget");
    }

    public async skillMapCellTarget(
        payload: SkillMapCellTargetPayload,
        resolved: (response: SkillMapCellTargetResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as SkillMapCellTargetResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default SkillMapCellTargetService;
